import React, {useEffect} from 'react';
import {Field} from 'redux-form';
import {useSelector} from "react-redux";
import ReduxInputComponent from "./ReduxComponent/ReduxInputComponent";

const Input = ({itemCols, name, value, placeholder = '', setError, disabled = false, numbersOnly = false}) => {
    const error = useSelector(state => state.customValidationErrors.errors[name]);
    useEffect(() => {
        setError(!!error);
    }, [error])

    return (
        <div className={itemCols}>
            {error && <div className="input-error2">{error}</div>}
            <Field component={ReduxInputComponent}
                   type="text"
                   id={name}
                   name={name}
                   disabled={disabled}
                   className="form-control form-control-sm"
                   value={value}
                   placeholder={placeholder}
                   numbersOnly={numbersOnly}
                   autoComplete={Math.random().toString(36).substring(2, 15)}
            />
        </div>
    );
};

export default Input;